import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalStatusService {

  constructor() { }
  hasOpenModals: BehaviorSubject<boolean> = new BehaviorSubject(false);
}
